import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">
            <div className="footer-logo-icon">C</div>
            <span className="footer-logo-text">Contextly AI</span>
          </div>
          <p className="footer-tagline">
            Empowering teams with intelligent document processing and RAG-based search. Made for the future of work.
          </p>
          <div className="footer-social">
            <button aria-label="GitHub"><i className="fa fa-github"></i></button>
            <button aria-label="Share"><i className="fa fa-share-alt"></i></button>
            <button aria-label="RSS"><i className="fa fa-rss"></i></button>
          </div>
        </div>

        <div className="footer-links-group">
          <h4>Product</h4>
          <Link to="/features">Features</Link>
          <Link to="/solutions">Integrations</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/docs">Changelog</Link>
        </div>

        <div className="footer-links-group">
          <h4>Resources</h4>
          <Link to="/docs">Documentation</Link>
          <Link to="/docs">API Reference</Link>
          <Link to="/docs">Community</Link>
          <Link to="/docs">Blog</Link>
        </div>

        <div className="footer-links-group">
          <h4>Company</h4>
          <Link to="/platform">About</Link>
          <Link to="/platform">Legal</Link>
          <Link to="/platform">Contact</Link>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Contextly AI Inc. All rights reserved.</p>
        <div className="footer-bottom-right">
          <span className="footer-status"><span className="footer-status-dot"></span> All systems operational</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
